import React, { ReactNode, useState } from 'react';
import styles from './ute-generate-otp.module.scss';
import UTEButton from '../ute-button';
import PasswordLockIcon from 'src/assets/svg/password-lock-icon';
import { useDeviceType } from 'src/hooks/useDeviceType';

type UTEGenerateOTPProps = {
	headerText?: ReactNode;
	subHeaderText?: ReactNode;
	otpSubmitText?: ReactNode;
	handleOnClickEvent: () => void;
};

const UTEGenerateOTP: React.FC<UTEGenerateOTPProps> = ({
	headerText,
	subHeaderText,
	otpSubmitText,
	handleOnClickEvent,
}) => {
	const deviceType = useDeviceType();
	const [isGenerateOTPDisabled, setIsGenerateOTPDisabled] = useState<boolean>(false);

	return (
		<>
			<PasswordLockIcon className={styles.passwordLockIcon} />
			<div className='uteLoginHeader'>{headerText ?? <>Verify&nbsp;your&nbsp;identity</>}</div>
			<div className={`uteLoginSubHeader ${styles.subHeader}`}>
				{subHeaderText ?? (
					<>
						To become an authorized user, verify your identity. {deviceType === 'desktop' ? <br /> : ' '}
						We will send you a One-Time Access Code {deviceType === 'desktop' ? <br /> : ' '}
						to your mobile number.
					</>
				)}
			</div>

			<div className={styles.confirmContainer}>
				<UTEButton
					text={otpSubmitText ?? 'Send Code'}
					className={styles.confirm}
					onClick={handleOnClickEvent}
					disabled={isGenerateOTPDisabled}
					dataTestAuto='5150ad4e-c4d9-46a9-ae9c-c95a905d96f7'
				/>
			</div>
		</>
	);
};

export default UTEGenerateOTP;
